import React from "react";

// Services
import { getTranslateByKey } from "@/main/services/utils";

// Components
import Button from "@/main/components/shared/button/button";
import SecondaryButton from "@/main/components/shared/button/secondaryButton";

// Components/Styles Local
import * as S from "./styles";
import KogModalFadeComponent from "../../modal/ModalFadeComponent";

interface IKOGModalConfirmProps {
	isOpenModal: boolean;
	titleModal: string | React.ReactNode;
	titleButtonCancel?: string;
	titleButtonConfirm?: string;
	setIsOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
	closeModal: () => void;
	onCancel: () => void;
	onConfirm: () => void;
}

function KOGModalConfirm({
	titleModal,
	titleButtonCancel = getTranslateByKey("information.no"),
	titleButtonConfirm = getTranslateByKey("information.yes"),
	closeModal,
	onCancel,
	onConfirm,
}: IKOGModalConfirmProps) {
	function handleModalCancel(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
		e.preventDefault();
		e.stopPropagation();
		onCancel();
	}

	function handleModalConfirm(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
		e.preventDefault();
		e.stopPropagation();
		closeModal();
		onConfirm();
	}
	const isStringTitleModal = (value: string | React.ReactNode): value is string => typeof value === "string";

	return (
		<S.BoxModal>
			{isStringTitleModal(titleModal) ? <S.TitleModal>{titleModal}</S.TitleModal> : titleModal}
			<S.AreaButtons>
				<SecondaryButton type="button" onClick={handleModalCancel}>
					{titleButtonCancel}
				</SecondaryButton>
				<Button type="button" onClick={handleModalConfirm}>
					{titleButtonConfirm}
				</Button>
			</S.AreaButtons>
		</S.BoxModal>
	);
}

function WrapperKOGModalConfirm(props: IKOGModalConfirmProps) {
	return (
		<KogModalFadeComponent isInModal open={props.isOpenModal} setOpen={props.setIsOpenModal}>
			{props.isOpenModal ? <KOGModalConfirm {...props} /> : <div />}
		</KogModalFadeComponent>
	);
}

export default WrapperKOGModalConfirm;
